import { AUTH_TYPES } from "./authConstants";
import { MAP_URL } from "../constants/urls";

const { SERVER } = require("../constants");

export const AuthProvider = {
  login: ({ username, password }) => {
    const fcm_token = localStorage.getItem("fcm_token")
    const req = new Request(`${SERVER}/${MAP_URL['login']}`, {
      method: "POST",
      body: JSON.stringify({ phoneNumber: username, code: password, fcm: fcm_token }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(req)
      .then((res) => {
        if (res.status < 200 || res.status >= 300) {
          throw new Error(res.statusText);
        }
        return res.json();
      })
      .then((res) => {
        const { Authorization, role, roles, admin } = res.result;
        localStorage.setItem("admin", JSON.stringify(admin));

        localStorage.setItem("username", admin.name);
        localStorage.setItem("userId", admin.objectId);
        localStorage.setItem(AUTH_TYPES.AUTHORIZATION, Authorization);
        localStorage.setItem(AUTH_TYPES.ROLE, role);
        localStorage.setItem(AUTH_TYPES.ROLES, roles);


      });
  },
  logout: () => {
    localStorage.removeItem(AUTH_TYPES.AUTHORIZATION);
    return Promise.resolve();
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () =>
    localStorage.getItem(AUTH_TYPES.AUTHORIZATION) ? Promise.resolve() : Promise.reject(),
  getPermissions: () => {
    // const role = localStorage.getItem(AUTH_TYPES.ROLE);
    const roles = localStorage.getItem(AUTH_TYPES.ROLES);
    return (roles) ? Promise.resolve(roles) : Promise.reject();
  },
};
